module.exports = __webpack_public_path__ + "static/media/HelveticaNeueLTStd-Lt.24ec703c.woff2";